import React, { useEffect, useState } from 'react';
import './liedseite.css';
import { Link, useParams } from 'react-router-dom';
import { loadLied as loadLiedAusSpeicher } from '../liederStore';
import { kategorieLabel } from '../buecher';
import { trackEreignis } from '../tracking';

function LiedDetail() {
  const { id } = useParams();
  const [lied, setLied] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isFavorite, setIsFavorite] = useState(false);

  function getFavorites() {
    return JSON.parse(localStorage.getItem('favorites') || '[]');
  }

  function checkFavorite(songId) {
    const favorites = getFavorites().map(String);
    return favorites.includes(String(songId));
  }

  useEffect(() => {
    if (lied?.name) trackEreignis('lied', lied.name);
  }, [lied?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setIsFavorite(checkFavorite(id));
    let cancelled = false;

    async function loadLied() {
      try {
        setLoading(true);
        setError('');

        const record = await loadLiedAusSpeicher(id);

        if (!cancelled) {
          setLied(record);
        }
      } catch (err) { } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadLied();

    return () => {
      cancelled = true;
    };
  }, [id]);

  function manageFavorite(songId) {
    const favorites = getFavorites().map(String);
    const normalizedId = String(songId);

    if (!favorites.includes(normalizedId)) {
      const updatedFavorites = [...favorites, normalizedId];
      localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
      setIsFavorite(true);
      return;
    }

    const updatedFavorites = favorites.filter((favId) => favId !== normalizedId);
    localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
    setIsFavorite(false);
  }
  return (
    <>
      {!loading && !error && lied && (
        <>
        <div id='liedseite_body'>
          <div className={`lied_info${kategorieLabel(lied.kategorie).length > 30 ? ' lied_info_lang' : ''}`}>
            
            
            <div className='infoheader'>
              <div className='titel_block'>
              <h2 className='liedseite_titel'>{lied.name}</h2>
              {/*<div className='kategorie'>{lied.id} - {kategorieLabel(lied.kategorie)}</div>*/}
              <div className='tonlage'>{lied.tonlage}</div>
              </div>
              <button type='button' className='fav_btn' aria-label='Zu Favoriten' onClick={() => manageFavorite(lied.id)}>
                {isFavorite ? 'favorite' : 'favorite_border'}
              </button>
              
            </div>
            <div className='kategorie'>{kategorieLabel(lied.kategorie)}</div>
          </div>
          
            <div className='lied_content'>
              {lied.bloecke.map((block, index) => (
                <div
                  key={`${block.block_typ}-${block.reihenfolge}-${index}`}
                  className={block.block_typ === 'chor' ? 'chor' : 'strophe'}
                >
                  {block.text}
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default LiedDetail;
